import { TApplicationState } from '../../types/redux';

export function getSiteType(state: TApplicationState) {
  return state.analytics.siteType;
}
